import { render, staticRenderFns } from "./importPtosCentros.vue?vue&type=template&id=37b429f6&"
import script from "./importPtosCentros.vue?vue&type=script&lang=js&"
export * from "./importPtosCentros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports